<!-- =========================================================================================
  File Name: UserEitButtons.vue
  Description: User Edit buttons
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
  <div class="centerx">
    <vs-popup
        class="user-company-assign-modal"
        title="Assign a company"
        :active="value"
        button-close-hidden>
      <v-select
          class="w-full"
          :clearable="false"
          v-model="selectedCompany"
          :options="companyOptions"
      />
      <div class="vx-col w-full text-right my-3">

        <vs-button class="ml-3" @click="update" color="light">
          Update Contacts
        </vs-button>
        <vs-button class="ml-3" @click="cancel">
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  props: {
    value: {
      default:false,
      type: Boolean
    },
    selectedContacts: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
      isActive: false,
      selectedCompany: null,

      rawCompanies: [],
    }
  },
  watch: {},
  computed: {
    companyOptions() {
      if (!this.rawCompanies) {
        return [];
      }

      return this.rawCompanies.map(({id, CompanyCode, CompanyName}) => {
        return {label: `${CompanyName} - ${CompanyCode}`, value: id}
      })
    },
  },
  methods: {
    update() {
      if (this.selectedCompany === null) {
        this.$emit('error', 'Please select a company');

        return;
      }

      this.updateContacts();
    },
    async updateContacts() {
      try {
        const { data } = await this.$api.companies.assignUsers(
            this.selectedCompany.value,
            this.selectedContacts
        );
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Could not assign contact to company. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })

        return false
      }

      this.$emit('updated');
    },
    cancel() {
      this.$emit('cancel');
    },
    async getCompanies() {
      try {
        const { data } = await this.$api.companies.all();
        this.rawCompanies = data.data;
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of companies. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
  },
  mounted () {
    this.getCompanies();
  }
}
</script>

<style lang="scss">
  .vs-popup--content {
    overflow: visible;
  }
</style>
